import http from '../_http'

const dashboard = {
  allDashboard: (m) => { return http.post(`manager/wmds/dashboard`, m); },
  monthDashboard: (m) => { return http.get(`manager/wmds/dashboard/month`, m); },
  weekDashboard: (m) => { return http.get(`manager/wmds/dashboard/week`, m); },

  //result
  resultDashboard: (m) => { return http.get(`manager/wmds/dashboard/result`, m); },

  //detect
  detectDashboard: (m) => { return http.get(`manager/wmds/dashboard/detect`, m); },
}

export default dashboard

export { dashboard }